import { Component } from "react";
import { withRouter } from "../../../withRouter";
import axios from "axios";
import cookie from "react-cookies";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import $ from "jquery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { ecommerceapiUrl, clientheaderconfig } from "../../Helpers/Config";
import { showLoader, hideLoader, showAlert, isEmpty, isSingleSelect, uploadFile, removeFile } from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Editor from "../Layout/Editor";

var module = "category";
var moduleName = "Categories";
var modulePath = "/clientpanel/ecom-categories";
var dayList = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
var dayListExist = [
  { day: "Mon", checked: "No", start: "", end: "" },
  { day: "Tue", checked: "No", start: "", end: "" },
  { day: "Wed", checked: "No", start: "", end: "" },
  { day: "Thu", checked: "No", start: "", end: "" },
  { day: "Fri", checked: "No", start: "", end: "" },
  { day: "Sat", checked: "No", start: "", end: "" },
  { day: "Sun", checked: "No", start: "", end: "" },
];
const companyEnableTimeSlotDateBased = cookie.load("companyEnableTimeSlotDateBased") ?? "false";
let defaultTimeAvailablity = [
  {
    title: "Fullfillment day(date) and time based product availability",
    type: "fullfillmentdate",
    data: [
      {
        daybased: [{ day: "", from: "", to: "", dateList: [], stock: "", validate: "" }],
      },
    ],
  },
];

class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editID: this.props.params?.EditID || "",
      pageloading: false,
      clientdata: {
        categoryName: "",
        categoryOutletID: [],
        categoryAvailabilityID: [],
        categoryCustomTitle: "",
        categoryShortDescription: "",
        categoryLongDescription: "",
        categorySequence: "",
        categoryLeadTime: "",
        categoryImage: "",
        categoryStatus: "",
        categoryEnableTimeAvailability:false,
        categoryTimeAvailability: defaultTimeAvailablity,
      },
      btndisabled: false,
      loading: true,
      tatList: [],
      availabiltyList: [],
      formpost: [],
      companyDetail: [],
      outletList: [],
      enableTimeAvailability: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.loadAvailabilty();
    this.loadOutlet();
    this.getSettings();
    if (this.state.editID !== "") {
      var params = {
        params: "",
        url: `${ecommerceapiUrl}${module}/detail/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          setTimeout(() => {
            this.props.navigate(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata && this.state.editID !== "") {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;
          var categoryStatus = result.categoryStatus === "A" ? "Active" : "Inactive";
          var status =
            result.categoryStatus !== "" && result.categoryStatus !== null
              ? {
                  label: categoryStatus,
                  value: result.categoryStatus,
                }
              : "";

          var updcategoryTimeAvailability = [];
          if (result.categoryTimeAvailability !== "" && result.categoryTimeAvailability !== null) {
            updcategoryTimeAvailability = JSON.parse(result.categoryTimeAvailability);
          } else {
            updcategoryTimeAvailability = defaultTimeAvailablity;
          }
          var clientupdatedata = {
            categoryName: result.categoryName,
            categoryOutletID: result?.categoryOutletID ?? [],
            categoryAvailabilityID: result.categoryAvailabilityID,
            categoryCustomTitle: result.categoryCustomTitle,
            categoryShortDescription: result.categoryShortDescription !== "" && result.categoryShortDescription !== null ? result.categoryShortDescription : "",
            categoryLongDescription: result.categoryLongDescription !== "" && result.categoryLongDescription !== null ? result.categoryLongDescription : "",
            categorySequence: result.categorySequence,
            categoryLeadTime: result.categoryLeadTime,
            categoryImage: result.categoryImage,
            categoryEnableTimeAvailability:result?.categoryEnableTimeAvailability || false,
            categoryTimeAvailability: updcategoryTimeAvailability,
            categoryStatus: status,
          };
          this.setState({ clientdata: clientupdatedata, pageloading: false });
        } else {
          this.setState({ pageloading: false });
          this.props.navigate(modulePath);
          showAlert("Error", "Invalid Category", "error");
        }
      });
    }
  }
  loadOutlet() {
    var urlShringTxt = ecommerceapiUrl + "outlet/dropDownList";
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ outletList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  loadAvailabilty() {
    var urlShringTxt = ecommerceapiUrl + "availability/companydropDownList";
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ availabiltyList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  getSettings() {
    var urlShringTxt = ecommerceapiUrl + "company/getCompanySettings";
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.result;
          const enableTimeAvailability = result?.companyEnableProductTimeAvailability ?? false;
          this.setState({ enableTimeAvailability });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  fieldChange = (field, value) => {
    this.setState(update(this.state, { clientdata: { [field]: { $set: value } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.clientdata;

    let categoryOutletID = postData.categoryOutletID.length > 0 ? postData.categoryOutletID.map((item) => item.value) : [];
    let categoryAvailabilityID = postData.categoryAvailabilityID.length > 0 ? postData.categoryAvailabilityID.map((item) => item.value) : [];
    const editorContent = $("#editorContent").val();
    const editorContent1 = $("#editorContent1").val();

    let timeAvail = 0;
    let categoryTimeAvailability =  postData.categoryTimeAvailability;
    if(categoryTimeAvailability.length>0) {
      categoryTimeAvailability.map((item)=> {
        item.data.map((aitem)=> {
          const daybased =  aitem?.daybased || [];
          if(daybased.length>0) {
          aitem.daybased.map((bitem)=> {
            if(bitem.day!=="" || bitem.from!=="" || bitem.stock!=="" || bitem.to!=="") {
              timeAvail++;
            }
            const dateList = bitem?.dateList || [];
            if(dateList.length>0) {
              dateList.map((citem)=> {
                if(citem.fromDate!=="" && citem.toDate!=="") {
                  timeAvail++;
                }
                return citem;
              })
            }
            return bitem;
          })
          }
          return aitem;
        })
        return item;
      })
    }
    if(timeAvail===0) {
      categoryTimeAvailability = '';
    }


    var postObject = {
      categoryName: postData.categoryName,
      categoryOutletID: postData.categoryOutletID.length > 0 ? categoryOutletID.join(",") : "",
      categoryAvailabilityID: categoryAvailabilityID.length > 0 ? categoryAvailabilityID.join(",") : "",
      categoryCustomTitle: postData.categoryCustomTitle,
      categoryShortDescription: editorContent,
      categoryLongDescription: editorContent1,
      categorySequence: postData.categorySequence,
      categoryLeadTime: postData.categoryLeadTime,
      categoryImage: postData.categoryImage,
      categoryEnableTimeAvailability:postData?.categoryEnableTimeAvailability || false,
      categoryTimeAvailability: (categoryTimeAvailability!=="")?JSON.stringify(categoryTimeAvailability):'',
      categoryStatus: postData?.categoryStatus?.value ?? "A",
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, "client", method, "ecom");
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"ecom-categories"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button type="button" className="btn btn-outline-primary waves-effect">
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.clientdata}
                  btndisabled={this.state.btndisabled}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  sateValChange={this.sateValChange}
                  error_msg={this.state.error_msg}
                  outletList={this.state.outletList}
                  availabiltyList={this.state.availabiltyList}
                  settings={{ enableTimeAvailability: this.state.enableTimeAvailability }}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop: $(document).find("#modulefrm .is-invalid:first").offset().top - 100,
                          },
                          500,
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method, urlType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method, urlType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));

function validationConfig(props) {
  const { categoryName, categoryStatus } = props.fields;

  return {
    fields: ["categoryName", "categoryStatus"],

    validations: {
      categoryName: [[isEmpty, categoryName]],
      categoryStatus: [[isSingleSelect, categoryStatus]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.setContent = this.setContent.bind(this);
    this.setContentLong = this.setContentLong.bind(this);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  handleCheckChange(name, value) {
    this.props.onChange(name, value.target.checked);
  }

  setContent(value, name) {
    this.props.onChange("categoryShortDescription", value);
  }
  setContentLong(value, name) {
    this.props.onChange("categoryLongDescription", value);
  }

  async uplaodFiles(imageType) {
    var loadID = "";
    var loadCont = "";
    if (imageType === "categoryImage") {
      loadID = "ImageContainer";
      loadCont = "ImageDetails";
    }
    this.props.sateValChange("btndisabled", true);
    showLoader(loadCont);
    showLoader(loadID);
    var imagefile = document.querySelector("#" + imageType);
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "category", "client", "ecom");
    if (fileDetail.status === "ok") {
      this.props.onChange(imageType, fileDetail.url);
    }
    hideLoader(loadID);
    hideLoader(loadCont);
    $("#" + imageType).val("");
    this.props.sateValChange("btndisabled", false);
  }
  async removeImage(fileNamme, imageType, e) {
    e.preventDefault();
    var loadCont = "";
    if (imageType === "categoryImage") {
      loadCont = "ImageDetails";
    }
    showLoader(loadCont);
    var fileDetail = await removeFile(fileNamme, "client", "ecom");
    if (fileDetail.status === "ok") {
      hideLoader(loadCont);
      this.props.onChange(imageType, "");
    }
  }
  handleChangeCheck(dayIndex, elementType, event) {
    var value = event.target.checked === true ? "Yes" : "No";
    //this.updateDayAvail(dayIndex, elementType, value);
  }
  /* handleChangeAvailDate(dayIndex, elementType, selectDate) {
    this.updateDayAvail(dayIndex, elementType, selectDate);
  }
  
  updateDayAvail(dayIndex, elementType, value) {
    var categoryTimeAvailability = this.props.fields.categoryTimeAvailability;
    var updcategoryTimeAvailability = [];
    categoryTimeAvailability.map((item, index) => {
      if (index === dayIndex) {
        var start = item.start;
        var end = item.end;
        var checked = item.checked;
        if (elementType === "start") {
          start = value;
        } else if (elementType === "end") {
          end = value;
        } else if (elementType === "checked") {
          checked = value;
          start = "";
          end = "";
        }
        updcategoryTimeAvailability.push({
          day: item.day,
          checked: checked,
          start: start,
          end: end,
        });
      } else {
        updcategoryTimeAvailability.push(item);
      }
      return "";
    });
    this.props.onChange("categoryTimeAvailability", updcategoryTimeAvailability);
  } */

  addNew(selectIndex, type) {
    var categoryTimeAvailability = this.props.fields.categoryTimeAvailability;
    var updatedcategoryTimeAvailability = [];
    categoryTimeAvailability.map((item, index) => {
      if (index === selectIndex) {
        var updateData = [];
        var daybased = item.data[0].daybased;
        var datebased = item.data[1].datebased;
        if (type === "daybased") {
          daybased.push({
            day: "",
            from: "",
            to: "",
            stock: "",
            validate: "",
          });
        } else if (type === "datebased") {
          datebased.push({
            from: "",
            to: "",
            stock: "",
            validate: "",
          });
        }
        updateData.push({ daybased: daybased }, { datebased: datebased });
        updatedcategoryTimeAvailability.push({
          title: item.title,
          type: item.type,
          data: updateData,
        });
      } else {
        updatedcategoryTimeAvailability.push(item);
      }
      return "";
    });
    this.props.onChange("categoryTimeAvailability", updatedcategoryTimeAvailability);
  }

  deleteAvailSlot(avilindex, avildayIndex, type) {
    let categoryTimeAvailability = this.props.fields.categoryTimeAvailability;

    let getAvil = categoryTimeAvailability[avilindex];
    if (type === "daybased") {
      let updItem = [];
      getAvil.data[0].daybased.map((dayItem, dayIndex) => {
        if (dayIndex !== avildayIndex) {
          updItem.push(dayItem);
        }
        return "";
      });
      getAvil.data[0].daybased = updItem;
    }
    if (type === "datebased") {
      let updItem_ = [];
      getAvil.data[1].datebased.map((dayItem, dayIndex) => {
        if (dayIndex !== avildayIndex) {
          updItem_.push(dayItem);
        }
        return "";
      });
      getAvil.data[1].datebased = updItem_;
    }
    categoryTimeAvailability[avilindex] = getAvil;
    this.props.onChange("categoryTimeAvailability", categoryTimeAvailability);
  }

  handleChangeCheckBox(type, dayIndex, typebase, elementType, event) {
    this.updateDayAvail(type, dayIndex, typebase, elementType, event.target.value, event.target.checked);
  }
  handleChangeAvailDate(type, dayIndex, typebase, elementType, selectDate) {
    this.updateDayAvail(type, dayIndex, typebase, elementType, selectDate);
  }
  handleChangeText(type, dayIndex, typebase, elementType, event) {
    this.updateDayAvail(type, dayIndex, typebase, elementType, event.target.value);
  }
  myFilter(elm) {
    return elm != null && elm !== false && elm !== "";
  }

  handleChangeAvailDateUPD(selectIndex, dayIndex, UPDIndex, type, upKey, selectedDate) {
    const categoryTimeAvailability = this.props.fields.categoryTimeAvailability;
    let updatedcategoryTimeAvailability = [];

    categoryTimeAvailability.map((item, index) => {
      if (index === selectIndex) {
        let updateData = [];
        let daybased = item.data[0].daybased;

        if (type === "daybased") {
          let dateList = daybased[dayIndex].dateList || [];

          if (dateList.length === 0) {
            dateList.push({ fromDate: "", toDate: "" });
          }
          dateList[UPDIndex][upKey] = selectedDate;
          daybased[dayIndex].dateList = dateList; // ✅ assign back
        }
        updateData.push({ daybased: daybased });

        updatedcategoryTimeAvailability.push({
          title: item.title,
          type: item.type,
          data: updateData,
        });
      } else {
        updatedcategoryTimeAvailability.push(item);
      }

      return "";
    });
    this.props.onChange("categoryTimeAvailability", updatedcategoryTimeAvailability);
  }
  removeDateList(selectIndex, dayIndex, removeIndex, type) {
    const categoryTimeAvailability = this.props.fields.categoryTimeAvailability;
    let updatedcategoryTimeAvailability = [];

    categoryTimeAvailability.map((item, index) => {
      if (index === selectIndex) {
        let updateData = [];
        let daybased = item.data[0].daybased;

        if (type === "daybased") {
          let dateList = daybased[dayIndex].dateList || [];
          dateList.splice(removeIndex, 1);
          daybased[dayIndex].dateList = dateList;
        }
        updateData.push({ daybased: daybased });

        updatedcategoryTimeAvailability.push({
          title: item.title,
          type: item.type,
          data: updateData,
        });
      } else {
        updatedcategoryTimeAvailability.push(item);
      }

      return "";
    });

    this.props.onChange("categoryTimeAvailability", updatedcategoryTimeAvailability);
  }

  addDateList(selectIndex, dayIndex, type) {
    const categoryTimeAvailability = this.props.fields.categoryTimeAvailability;
    let updatedcategoryTimeAvailability = [];

    categoryTimeAvailability.map((item, index) => {
      if (index === selectIndex) {
        let updateData = [];
        let daybased = item.data[0].daybased;

        if (type === "daybased") {
          let dateList = daybased[dayIndex].dateList || [];

          if (dateList.length === 0) {
            dateList.push({ fromDate: "", toDate: "" });
          }

          dateList.push({ fromDate: "", toDate: "" });
          daybased[dayIndex].dateList = dateList; // ✅ assign back
        }
        updateData.push({ daybased: daybased });

        updatedcategoryTimeAvailability.push({
          title: item.title,
          type: item.type,
          data: updateData,
        });
      } else {
        updatedcategoryTimeAvailability.push(item);
      }

      return "";
    });
    this.props.onChange("categoryTimeAvailability", updatedcategoryTimeAvailability);
  }

  updateDayAvail(type, dayIndex, typebase, elementType, value, checkedStatus = null) {
    var categoryTimeAvailability = this.props.fields.categoryTimeAvailability;
    var updatedcategoryTimeAvailability = [];
    categoryTimeAvailability.map((item) => {
      if (item.type === type) {
        var updateData = [];
        var daybased = item.data[0].daybased;
        var datebased = item.data[1]?.datebased || "";
        if (typebase === "daybased") {
          var updatedDayBase = [];
          daybased.map((dayItems, dayItemIndex) => {
            var updday = dayItems.day;
            var updfrom = dayItems.from;
            var updto = dayItems.to;
            var updstock = dayItems.stock;
            var updvalidate = dayItems.validate;
            if (dayIndex === dayItemIndex) {
              if (elementType === "day") {
                var splitupdday = updday.split(",").filter(this.myFilter);
                if (checkedStatus === true) {
                  splitupdday.push(value);
                } else {
                  const index = splitupdday.indexOf(value);
                  splitupdday.splice(index, 1);
                }
                updday = splitupdday.length > 0 ? splitupdday.join(",") : "";
              } else if (elementType === "fromtime") {
                updfrom = value;
              } else if (elementType === "totime") {
                updto = value;
              } else if (elementType === "stock") {
                updstock = value;
              } else if (elementType === "validate") {
                if (checkedStatus === true) {
                  updvalidate = value;
                } else {
                  updvalidate = "";
                }
              }
            }
            updatedDayBase.push({
              day: updday,
              from: updfrom,
              to: updto,
              stock: updstock,
              dateList: dayItems.dateList,
              validate: updvalidate,
            });
            return "";
          });
          daybased = updatedDayBase;
        }
        if (typebase === "datebased" && datebased !== "") {
          var updatedDateBase = [];
          datebased.map((dateItems, dateItemIndex) => {
            var updfrom = dateItems.from;
            var updto = dateItems.to;
            var updstock = dateItems.stock;
            var updvalidate = dateItems.validate;
            if (dayIndex === dateItemIndex) {
              if (elementType === "fromdate") {
                updfrom = value;
              } else if (elementType === "todate") {
                updto = value;
              } else if (elementType === "stock") {
                updstock = value;
              } else if (elementType === "validate") {
                if (checkedStatus === true) {
                  updvalidate = value;
                } else {
                  updvalidate = "";
                }
              }
            }
            updatedDateBase.push({
              from: updfrom,
              to: updto,
              stock: updstock,
              validate: updvalidate,
            });
            return "";
          });
          datebased = updatedDateBase;
        }
        updateData.push({ daybased: daybased }, { datebased: datebased });
        updatedcategoryTimeAvailability.push({
          title: item.title,
          type: item.type,
          data: updateData,
        });
      } else {
        updatedcategoryTimeAvailability.push(item);
      }
      return "";
    });
    this.props.onChange("categoryTimeAvailability", updatedcategoryTimeAvailability);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgCatName,
      errMsgStatus = "";
    if ($validation.categoryName.error.reason !== undefined) {
      errMsgCatName = $validation.categoryName.show && <span className="error">{$validation.categoryName.error.reason}</span>;
    }
    if ($validation.categoryStatus.error.reason !== undefined) {
      errMsgStatus = $validation.categoryStatus.show && <span className="error">{$validation.categoryStatus.error.reason}</span>;
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3">
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={errMsgCatName !== "" && errMsgCatName !== false && errMsgCatName !== undefined ? "form-control is-invalid" : "form-control"}
                name="categoryName"
                value={fields.categoryName}
                {...$field("categoryName", (e) => onChange("categoryName", e.target.value))}
              />
              <label htmlFor="categoryName">
                Category Name <span className="error">*</span>
              </label>
              {errMsgCatName}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                id="categoryCustomTitle"
                name="categoryCustomTitle"
                value={fields.categoryCustomTitle}
                placeholder="Custom Name"
                aria-label="Text input with checkbox"
                {...$field("categoryCustomTitle", (e) => onChange("categoryCustomTitle", e.target.value))}
              />
              <label className="select-box-label">Custom Name</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.categoryOutletID}
                onChange={this.handleSelectChange.bind(this, "categoryOutletID")}
                placeholder={"Select Outlet"}
                options={this.props.outletList}
                isClearable={true}
                isMulti
              />
              <label className="select-box-label">Outlet</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.categoryAvailabilityID}
                onChange={this.handleSelectChange.bind(this, "categoryAvailabilityID")}
                isMulti
                placeholder="Select Availabilty"
                options={this.props.availabiltyList}
                isClearable={true}
              />
              <label className="select-box-label">Availabilty</label>
            </div>
          </div>
          <div className="col-md-12">
            <label>Short Description</label>
            <Editor IDName={"editorContent"} data={fields.categoryShortDescription} />
          </div>
          <div className="col-md-12">
            <label>Long Description</label>
            <Editor IDName={"editorContent"} data={fields.categoryLongDescription} />
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="categorySequence"
                value={fields.categorySequence}
                {...$field("categorySequence", (e) => onChange("categorySequence", e.target.value))}
              />
              <label htmlFor="categorySequence">Sequence</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="categoryLeadTime"
                value={fields.categoryLeadTime}
                {...$field("categoryLeadTime", (e) => onChange("categoryLeadTime", e.target.value))}
              />
              <label htmlFor="categoryLeadTime">Category Lead Time</label>
            </div>
          </div>
          <div className={errMsgStatus !== "" && errMsgStatus !== false && errMsgStatus !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.categoryStatus}
                onChange={this.handleSelectChange.bind(this, "categoryStatus")}
                placeholder="Select Status"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "Inactive" },
                ]}
                isClearable={true}
              />
              <label className="select-box-label">
                Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>
          <div className="col-md-6"></div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <div className="mb-3" id="ImageContainer">
                <label htmlFor="formFile" className="form-label">
                  Image
                </label>
                <input
                  className="form-control"
                  type="file"
                  id="categoryImage"
                  onChange={(event) => {
                    this.uplaodFiles("categoryImage", event);
                    return false;
                  }}
                />
              </div>
            </div>
            {fields.categoryImage !== "" && fields.categoryImage !== null && (
              <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                <div className="dz-details" id="ImageDetails">
                  <div className="dz-thumbnail">
                    <img alt="" src={fields.categoryImage} />
                  </div>
                </div>
                <a className="dz-remove" href="/" onClick={this.removeImage.bind(this, fields.categoryImage, "categoryImage")}>
                  Remove file
                </a>
              </div>
            )}
          </div>

          {this.props.settings.enableTimeAvailability && (
            <div>
              <h1 className="display-6 mb-0">Time Availability</h1>
              <div className="row g-3">
                <div className="col-md-3">
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`categoryEnableTimeAvailability`}
                      checked={fields?.categoryEnableTimeAvailability ?? false}
                      onChange={this.handleCheckChange.bind(this, "categoryEnableTimeAvailability")}
                    />
                    <label className="form-check-label" htmlFor={`categoryEnableTimeAvailability`}>
                      Enable Time Availability
                    </label>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="pro_advancedaytime_availability_div">
                    {fields.categoryTimeAvailability.map((item, index) => {
                      return (
                        <div key={index}>
                          <div className="pro_current_daydatewise_title">{item.title}</div>

                          <div className="col-md-12">
                            <div className="pro_daydatewise_availability">
                              <div className="row">
                                <div className={`col-md-12`}>
                                  <div className="pro_daywise_availability">
                                    <div className="pro_daywise_availability_main">
                                      <div className="pro_current_daywise_title">
                                        Day based availability
                                        <span className="mdi mdi-plus-box text-end" onClick={this.addNew.bind(this, index, "daybased")}></span>
                                      </div>
                                      {item.data[0].daybased.map((dayItem, dayIndex) => {
                                        var selectedday = dayItem.day !== "" && dayItem.day !== null ? dayItem.day.split(",") : [];
                                        const dateList_ = dayItem?.dateList || [];
                                        const dateList = dateList_.length > 0 ? dateList_ : [{ fromDate: "", toDate: "" }];
                                        console.log(dayList, "dayListdayListdayList");
                                        return (
                                          <div className="daywiseitem_text_div mb-2" key={dayIndex}>
                                            {item.data[0].daybased.length > 1 && (
                                              <div className="text-end">
                                                {" "}
                                                <span className="mdi mdi-trash-can-outline" onClick={this.deleteAvailSlot.bind(this, index, dayIndex, "daybased")}></span>
                                              </div>
                                            )}
                                            <div className="form-group daywiseitem_form_group">
                                              {dayList.map((day, dayListIndex) => {
                                                return (
                                                  <div className="form-check form-check-inline mt-3" key={dayListIndex}>
                                                    <input
                                                      className="form-check-input"
                                                      type="checkbox"
                                                      id={"day_" + dayIndex + "_" + dayListIndex + "_" + day}
                                                      value={day.toLowerCase()}
                                                      checked={selectedday.indexOf(day.toLowerCase()) >= 0 ? true : false}
                                                      onChange={this.handleChangeCheckBox.bind(this, item.type, dayIndex, "daybased", "day")}
                                                    />
                                                    <label className="form-check-label" htmlFor={"day_" + dayIndex + "_" + dayListIndex + "_" + day}>
                                                      {day}
                                                    </label>
                                                  </div>
                                                );
                                              })}
                                            </div>

                                            <div className="row">
                                              <div className="col-md-3">
                                                <div className="form-floating-outline mt-2 custm-date-box">
                                                  <DatePicker
                                                    className="form-control"
                                                    showTimeSelect
                                                    showTimeSelectOnly
                                                    timeIntervals={15}
                                                    selected={dayItem.from !== "" && dayItem.from !== null ? new Date(dayItem.from) : ""}
                                                    timeCaption="Time"
                                                    dateFormat="h:mm aa"
                                                    onChange={this.handleChangeAvailDate.bind(this, item.type, dayIndex, "daybased", "fromtime")}
                                                  />
                                                  <label className="select-box-label">From</label>
                                                </div>
                                              </div>
                                              <div className="col-md-3">
                                                <div className="form-floating-outline mt-2 custm-date-box">
                                                  {/* dayItem.from */}
                                                  <DatePicker
                                                    className="form-control"
                                                    showTimeSelect
                                                    showTimeSelectOnly
                                                    timeIntervals={15}
                                                    timeCaption="Time"
                                                    dateFormat="h:mm aa"
                                                    selected={dayItem.to !== "" && dayItem.to !== null ? new Date(dayItem.to) : ""}
                                                    minTime={dayItem.from ? new Date(dayItem.from) : new Date().setHours(0, 0, 0, 0)}
                                                    maxTime={new Date().setHours(23, 59, 59, 999)}
                                                    onChange={this.handleChangeAvailDate.bind(this, item.type, dayIndex, "daybased", "totime")}
                                                  />
                                                  <label className="select-box-label">To</label>
                                                </div>
                                              </div>
                                              <div className="col-md-3">
                                                <div className="form-floating-outline mt-2">
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    value={dayItem.stock}
                                                    onChange={this.handleChangeText.bind(this, item.type, dayIndex, "daybased", "stock")}
                                                    placeholder="Stock"
                                                  />
                                                </div>
                                              </div>
                                              <div className="col-md-3">
                                                <div className="form-check form-check-inline mt-3">
                                                  <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id={"day_" + index + "_" + dayIndex + "_validate"}
                                                    value="Yes"
                                                    checked={dayItem.validate === "Yes" ? true : false}
                                                    onChange={this.handleChangeCheckBox.bind(this, item.type, dayIndex, "daybased", "validate")}
                                                  />
                                                  <label className="form-check-label" htmlFor={"day_" + index + "_" + dayIndex + "_validate"}>
                                                    Validate
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                            {companyEnableTimeSlotDateBased === "true" && (
                                              <>
                                                {dateList.length > 0 &&
                                                  dateList.map((sdateitem, sdateIndex) => {
                                                    return (
                                                      <div className="row" key={sdateIndex}>
                                                        <div className="col-md-3">
                                                          <div className="form-floating-outline mt-3 custm-date-box">
                                                            <DatePicker
                                                              peekNextMonth
                                                              showMonthDropdown
                                                              showYearDropdown
                                                              dropdownMode="select"
                                                              className="form-control"
                                                              dateFormat="dd-MM-yyyy"
                                                              selected={sdateitem.fromDate !== "" && sdateitem.fromDate !== null ? new Date(sdateitem.fromDate) : ""}
                                                              onChange={this.handleChangeAvailDateUPD.bind(this, index, dayIndex, sdateIndex, "daybased", "fromDate")}
                                                            />
                                                            <label className="select-box-label">From Date</label>
                                                          </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                          <div className="form-floating-outline mt-3 custm-date-box">
                                                            <DatePicker
                                                              peekNextMonth
                                                              showMonthDropdown
                                                              showYearDropdown
                                                              dropdownMode="select"
                                                              className="form-control"
                                                              dateFormat="dd-MM-yyy"
                                                              minDate={sdateitem.fromDate !== "" && sdateitem.fromDate !== null ? new Date(sdateitem.fromDate) : new Date()}
                                                              selected={sdateitem.toDate !== "" && sdateitem.toDate !== null ? new Date(sdateitem.toDate) : ""}
                                                              onChange={this.handleChangeAvailDateUPD.bind(this, index, dayIndex, sdateIndex, "daybased", "toDate")}
                                                            />
                                                            <label className="select-box-label">To Date</label>
                                                          </div>
                                                        </div>
                                                        <div className="col-md-1 mt-4">
                                                          {dateList.length > 1 && (
                                                            <span className="mdi mdi-minus-box-outline" onClick={this.removeDateList.bind(this, index, dayIndex, sdateIndex, "daybased")}></span>
                                                          )}
                                                          {dateList.length - 1 === sdateIndex && (
                                                            <span className="mdi mdi-plus-box-outline" onClick={this.addDateList.bind(this, index, dayIndex, "daybased")}></span>
                                                          )}
                                                        </div>
                                                      </div>
                                                    );
                                                  })}
                                              </>
                                            )}
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* <h1 className="display-6 mb-0">Time Availability</h1> */}
          {/* fields.categoryTimeAvailability.map((item, index) => {
            return (
              <div className="row" key={index}>
                <div className="col-md-1">
                  <div className="form-check form-check-inline mt-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="low_stock_alert"
                      checked={item.checked === "Yes" ? true : false}
                      onChange={this.handleChangeCheck.bind(this, index, "checked")}
                    />
                    <label className="form-check-label" htmlFor="low_stock_alert">
                      {item.day}
                    </label>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-floating-outline mt-2 custm-date-box">
                    <DatePicker
                      className="form-control"
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      selected={item.start !== "" && item.start !== null ? new Date(item.start) : ""}
                      onChange={this.handleChangeAvailDate.bind(this, index, "start")}
                      disabled={item.checked === "Yes" ? false : true}
                    />
                    <label className="select-box-label">From</label>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-floating-outline mt-2 custm-date-box">
                    <DatePicker
                      className="form-control"
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      selected={item.end !== "" && item.end !== null ? new Date(item.end) : ""}
                      onChange={this.handleChangeAvailDate.bind(this, index, "end")}
                      disabled={item.checked === "Yes" ? false : true}
                    />
                    <label className="select-box-label">To</label>
                  </div>
                </div>
              </div>
            );
          }) */}

          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              disabled={this.props.btndisabled}
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                if (!this.props.btndisabled) {
                  this.props.$submit(onValid, onInvalid);
                }
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button type="reset" className="btn btn-label-secondary waves-effect">
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
